// import { Addon } from "./Addon"
import {resolve} from "../resolve/resolve"


export class Shake {

    /**
     * 
     * @param {*} base 
     * @param {Array<Addon>} addons 
     */
    constructor (base, addons) {
        this._base = base
        this._addons = addons
    }


    _getAddonAdditions(key) {
        let baseValue = resolve(key, this._base)
        let sumAddons = this._addons.filter(e => typeof resolve(key, e.additives) === 'number' || (Array.isArray(resolve(key, e.additives)) && resolve(key, e.additives)[0] === '+' ))
        let equalAddons = this._addons.filter(e => Array.isArray(resolve(key, e.additives)) && resolve(key, e.additives)[0] === '=')
        if (equalAddons.length === 0) {
            let addonValue = (sumAddons.map(a => resolve(key, a.additives)).filter(a => typeof a !== 'undefined')).reduce(function (acc, cur) {
                return acc + cur
            }, 0)
            return(baseValue + addonValue).toFixed(2)
        } else {
            return resolve(key, equalAddons[0].additives)[1]
        }
    }

    get base () {
        return this._base
    }

    get addons () {
        return this._addons
    }

    removeAddon (addon) {
        let removeIndex = this._addons.findIndex(a => a.title === addon.title)
        if (removeIndex != -1) {
            this._addons.splice(removeIndex, 1)
        }
    }

    get calories () {
        return this._getAddonAdditions('calories') 
    }

    get carbohydrate () {
        return this._getAddonAdditions('carbohydrate')
    }

    get sugar () {
        return this._getAddonAdditions('sugar')
    }

    get fiber () {
        return this._getAddonAdditions('fiber')
    }

    get fat () {
        return this._getAddonAdditions('fat')
    }

    get fattyAcids () {
        return {
            essential: this._getAddonAdditions('fattyAcids.essential'),
            multipleUnsaturatedFattyAcids: this._getAddonAdditions('fattyAcids.multipleUnsaturatedFattyAcids'),
            omega6: this._getAddonAdditions('fattyAcids.omega6'),
            omega3: this._getAddonAdditions('fattyAcids.omega3'),
            monoUnsaturatedFattyAcids: this._getAddonAdditions('fattyAcids.monoUnsaturatedFattyAcids'),
            saturatedFattyAcids: this._getAddonAdditions('fattyAcids.saturatedFattyAcids') 
        }
    }

    get salt () {
        return this._getAddonAdditions('salt') 
    }

    get protein () {
        return this._getAddonAdditions('protein') 
    }

    get essentialAminoAcids () {
        return {
            cysteine: this._getAddonAdditions('essentialAminoAcids.cysteine'),
            histidine: this._getAddonAdditions('essentialAminoAcids.histidine'), 
            isoleucine: this._getAddonAdditions('essentialAminoAcids.isoleucine'), 
            leucine: this._getAddonAdditions('essentialAminoAcids.leucine'),
            lysine: this._getAddonAdditions('essentialAminoAcids.lysine'),
            methionine: this._getAddonAdditions('essentialAminoAcids.methionine'), 
            phenylalanine: this._getAddonAdditions('essentialAminoAcids.phenylalanine'),  
            threonine: this._getAddonAdditions('essentialAminoAcids.threonine'),
            tryptophan: this._getAddonAdditions('essentialAminoAcids.tryptophan'), 
            valine: this._getAddonAdditions('essentialAminoAcids.valine')
        }
    }

    get noEssentialAminoAcids () {
        return {
            alanine: this._getAddonAdditions('noEssentialAminoAcids.alanine'),
            arginine: this._getAddonAdditions('noEssentialAminoAcids.arginine'),
            asparticAcid: this._getAddonAdditions('noEssentialAminoAcids.asparticAcid'),
            glutamicAcid: this._getAddonAdditions('noEssentialAminoAcids.glutamicAcid'),
            glycine: this._getAddonAdditions('noEssentialAminoAcids.glycine'),
            proline: this._getAddonAdditions('noEssentialAminoAcids.proline'),
            serine: this._getAddonAdditions('noEssentialAminoAcids.serine'),
            tyrosine: this._getAddonAdditions('noEssentialAminoAcids.tyrosine'),
        }
    }

    get vitamins () {
        return { 
            a: this._getAddonAdditions('vitamins.a'),
            retinoEquivalent: this._getAddonAdditions('vitamins.retinoEquivalent'),
            betaCarotin: this._getAddonAdditions('vitamins.betaCarotin'),
            b1: this._getAddonAdditions('vitamins.b1'),
            b2: this._getAddonAdditions('vitamins.b2'),
            b3: this._getAddonAdditions('vitamins.b3'),
            b5: this._getAddonAdditions('vitamins.b5'),
            b6: this._getAddonAdditions('vitamins.b6'),
            b9: this._getAddonAdditions('vitamins.b9'),
            b12: this._getAddonAdditions('vitamins.b12'),
            c: this._getAddonAdditions('vitamins.c'),
            d: this._getAddonAdditions('vitamins.d'),
            e: this._getAddonAdditions('vitamins.e'),
            h: this._getAddonAdditions('vitamins.h'),
            k: this._getAddonAdditions('vitamins.k')
        }
    }

    get minerals () {
        return {
            potassium: this._getAddonAdditions('minerals.potassium'),
            calcium: this._getAddonAdditions('minerals.calcium'),
            magnesium: this._getAddonAdditions('minerals.magnesium'),
            phosphor: this._getAddonAdditions('minerals.phosphor'),
            natrium: this._getAddonAdditions('minerals.natrium')
        }
    }

    get traceElements () {
        return {
            chromium: this._getAddonAdditions('traceElements.chromium'),
            iron: this._getAddonAdditions('traceElements.iron'),
            iodine: this._getAddonAdditions('traceElements.iodine'),
            copper: this._getAddonAdditions('traceElements.copper'),
            manganese: this._getAddonAdditions('traceElements.manganese'),
            fluoride: this._getAddonAdditions('traceElements.fluoride'),
            zinc: this._getAddonAdditions('traceElements.zinc'),
            selenium: this._getAddonAdditions('traceElements.selenium'),
        }
    }

    get chlorophyll () {
        return this._getAddonAdditions('chlorophyll')
    }

    //PriceCalculation
    get basePrice () {
        const difference = Math.round(this.calories/50)*50 - 500
        const steps = Math.ceil(difference / 50)
        return this.pureBasePrice + (25 * steps)
    }

    get pureBasePrice () {
        return 1790
    }

    get price () {
        let price = this.basePrice || 0
        price += (this._addons.map(a => a.price).reduce(function (acc, cur) {
            return acc + cur
        }))
        return price
    }

    toPlainObject () {
        return {
            addons: this.addons.map(addon => {
                return {
                    title: addon.title,
                    additives: addon.additives,
                    price: addon.price
                }
            }),
            base: this._base 
        }
    }

}